import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import Immutable from 'immutable';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import Checkbox from '@bibliocommons/base-checkbox';
import { Dropdown } from '@bibliocommons/base-dropdown';
import { SHELF_NAMES } from '../../../../../../constants/ShelfConstants';
import '../styles/CancelHoldShelfPrompt.scss';

const propTypes = {
  toAdd: PropTypes.bool,
  name: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool
};

class CancelHoldShelfPrompt extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleChangeAddTo', 'handleChangeShelf');
    this._checkboxId = _.uniqueId('shelf_checkbox_');
  }

  static getShelfOptions() {
    return Immutable.Map(SHELF_NAMES).valueSeq().toArray().map(name => ({
      label: <FormattedMessage id={`label_shelf_${name}`} />,
      value: name
    }));
  }

  handleChangeAddTo(toAdd) {
    this.props.handleChange({ toAdd });
  }

  handleChangeShelf(name) {
    this.props.handleChange({ name });
  }

  render() {
    return (
      <div className="cp-cancel-hold-shelf-prompt">
        <Checkbox
          inline
          className="add-to-shelf-checkbox"
          id={this._checkboxId}
          checked={this.props.toAdd}
          handleChange={this.handleChangeAddTo}
          label={<FormattedMessage id="label_also_move_shelf" />} />
        <Dropdown
          className="btn-flat btn btn-default"
          options={CancelHoldShelfPrompt.getShelfOptions()}
          selected={<FormattedMessage id={`label_my_shelf_${this.props.name}`} />}
          handleSelect={this.handleChangeShelf} />
      </div>
    );
  }
}

CancelHoldShelfPrompt.propTypes = propTypes;

export default CancelHoldShelfPrompt;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/cancel-hold-shelf-prompt/components/CancelHoldShelfPrompt.component.jsx